import React from 'react';


function Card(props) {
  return (
    <div className="flex justify-center items-center  bg-sky-950">
      <div className="bg-sky-900 p-2 rounded-2xl shadow-black shadow-lg w-48 md:w-70 h-52 md:h-56 mt-5 text-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{props.title}</h2>
        {props.children}
        
      </div>
    </div>
  );
}

export default Card;
